import { WebViewerInstance, Annotations } from '@pdftron/webviewer'
//TODO: Create a Subtype of QuoteModelRevision containing only properties that are used by it's consuming components
import { quoteModelRevisionWithHoles_quoteModelRevision as quoteModelRevisionWithHoles } from '@Builder/QuoteDetailPage/FilesTab/ConfigurationModal/__generated__/quoteModelRevisionWithHoles'

import {
    QuoteDetails_QuoteFragment as Quote,
    QuoteDetails_Quote_QuoteModels_Item_SelectedQuoteModelRevisionFragment as QuoteModelRevision,
    QmrDfmFeedback_QuoteModelRevisionFragment as qmrDfmFeedBackquoteModelRevision,
    AdditionalRequirementsRawPdfOcrDocument,
    AdditionalRequirementsRawPdfOcrQuery,
    AdditionalRequirementsRawPdfOcrQueryVariables,
    AdditionalRequirementsRawPdfOcrDataFragment as RawPdfOcrJson,
    AdminQuoteModelRevisionDataFragment,
} from '~/gql/graphql'
import { getByQuoteModelRevisionAttachmentId_getModelAttachmentOcrData as ModelAttachmentOcrData } from '~/redux-modules/dfm-layers/__generated__/getByQuoteModelRevisionAttachmentId'
import { types as GraphqlTypes } from '~/redux-modules/graphql'
import { coreQuoteDetails_quote_quoteModels_items_selectedQuoteModelRevision as CoreQuoteModelRevision } from '~/redux-modules/query-refactor/__generated__/coreQuoteDetails'

import { getModelAttachmentOCRDataQuery } from './queries'
import {
    SET_TECHNICAL_DRAWING_SECTION_TYPE,
    SET_TECHNICAL_DRAWING_SECTION_ALERT_TYPE,
    SET_QUOTE_MODEL_REVISIONS,
    SET_LOADING_DATA,
    SET_UPLOADING_LOADING_DATA,
    SET_ANALYZING_DATA,
    SET_PDFOCR_DATA,
    GET_PDFOCR_DATA_FAILURE,
    SET_WEBVIEWER_INSTANCE,
    SET_QUOTE,
    SET_SELECTED_TAB,
    SET_DRAWING_ANALYSIS_INSPECTION,
    CLEAR_PDFOCR_DATA,
    SET_GENERATED_DRAWING,
    SET_QMR_HOLE_DETAIL,
    SET_QMR_DFMFEEDBACK_REVISION,
    SET_EDIT_PDF_MODE,
    SET_ATTACHMENT_ANNOTATIONS_RESPONSE,
    SET_SHOW_LOADING,
    SET_ERROR_MESSAGE,
    SET_SHOW_RFQ_MODAL,
    SET_UN_SAVE_ANNOTATION,
    SET_PDF_USER_INFO_USERNAME,
    SET_OBFUSCATEFICTIVANNOTATATIONATTIBUTION,
    SET_PDF_URL,
    SET_TECHNICAL_SECTION_BACKGROUD_COLOUR_FOR_WARNING,
    SET_ADDITIONAL_REQUIREMENT_ROW_PDFOCR_DATA,
    SET_ADDITIONAL_REQUIREMENTS_RAW_PDFOCR_DATA_FAILURE,
} from './constants'
import {
    TechnicalDrawingSectionType,
    TechnicalDrawingAlertType,
    AnalyzingData,
    UploadLoadingData,
    LoadingData,
    SelectedTabValue,
    ShowDrawingButton,
    GeneratedDrawing,
} from './types'

export const setTechnicalDrawingSectionType = (
    technicalDrawingSectionType: TechnicalDrawingSectionType,
) => ({
    type: SET_TECHNICAL_DRAWING_SECTION_TYPE,
    technicalDrawingSectionType,
})

export const setTechnicalDrawingAlertType = (
    technicalDrawingAlertType: TechnicalDrawingAlertType,
) => ({
    type: SET_TECHNICAL_DRAWING_SECTION_ALERT_TYPE,
    technicalDrawingAlertType,
})

export const setSelectedQuoteModelRevisions = (
    selectedQuoteModelRevisions?: (
        | QuoteModelRevision
        | CoreQuoteModelRevision
        | AdminQuoteModelRevisionDataFragment
    )[],
) => ({
    type: SET_QUOTE_MODEL_REVISIONS,
    selectedQuoteModelRevisions,
})

export const setLoadingDataForAttachment = (attachingloading: LoadingData) => ({
    type: SET_LOADING_DATA,
    attachingloading,
})

export const setUploadLoadingDataForAttachment = (
    uploadingData: UploadLoadingData,
) => ({
    type: SET_UPLOADING_LOADING_DATA,
    uploadingData,
})

export const setAnalyzingDataForAttachment = (
    analyzingData: AnalyzingData,
) => ({
    type: SET_ANALYZING_DATA,
    analyzingData,
})

export const setGeneratedDrawingForAttachment = (
    generatedDrawing: GeneratedDrawing,
) => ({
    type: SET_GENERATED_DRAWING,
    generatedDrawing,
})

export const setSelectedTabForModal = (selectedTabName: SelectedTabValue) => ({
    type: SET_SELECTED_TAB,
    selectedTabName,
})

export const setPDFOCRData = (data: ModelAttachmentOcrData) => ({
    type: SET_PDFOCR_DATA,
    data,
})

export const setAddtionalRequirementsRawPDFOCRData = (
    data: RawPdfOcrJson | null,
) => ({
    type: SET_ADDITIONAL_REQUIREMENT_ROW_PDFOCR_DATA,
    data,
})

export const setPDFOCRDataFailure = (error: Error) => ({
    type: GET_PDFOCR_DATA_FAILURE,
    error,
})

export const setAdditionalRequirementsRawPDFOCRDataFailure = (
    error: string,
) => ({
    type: SET_ADDITIONAL_REQUIREMENTS_RAW_PDFOCR_DATA_FAILURE,
    error,
})

export const showDrawingButtonOnInspectionModal = (
    showDrawingButton: ShowDrawingButton,
) => ({
    type: SET_DRAWING_ANALYSIS_INSPECTION,
    showDrawingButton,
})

export const getPDFOCR = (id: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            if (!id) {
                return null
            }

            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient

            const response = await apolloClient.query({
                query: getModelAttachmentOCRDataQuery,
                variables: { quoteModelRevisionAttachmentId: id },
                fetchPolicy: 'network-only',
            })

            const {
                data: { getModelAttachmentOcrData },
            } = response

            dispatch(setPDFOCRData(getModelAttachmentOcrData))
        } catch (e) {
            dispatch(setPDFOCRDataFailure(e as Error))
        }
    }
}

export const getAdditionalRequirementsRawPDFOCR = (
    qmrId: string,
    retry = false,
) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient

            const response = await apolloClient.query<
                AdditionalRequirementsRawPdfOcrQuery,
                AdditionalRequirementsRawPdfOcrQueryVariables
            >({
                query: AdditionalRequirementsRawPdfOcrDocument,
                variables: { quoteModelRevisionId: qmrId },
                fetchPolicy: 'network-only',
            })

            const {
                data: { getRawPdfOcrJson },
            } = response

            if (retry && !getRawPdfOcrJson) {
                setTimeout(() => {
                    dispatch(getAdditionalRequirementsRawPDFOCR(qmrId, retry))
                }, 5000)
            } else {
                dispatch(
                    setAddtionalRequirementsRawPDFOCRData(getRawPdfOcrJson),
                )
            }
        } catch (e) {
            if (typeof e === 'string') {
                dispatch(setAdditionalRequirementsRawPDFOCRDataFailure(e))
            } else {
                dispatch(
                    setAdditionalRequirementsRawPDFOCRDataFailure(
                        'Error making call to additionalRequirementsRawPdfOcrQuery',
                    ),
                )
            }
        }
    }
}

export const clearPDFOCR = () => ({
    type: CLEAR_PDFOCR_DATA,
})

export const setWebviewerInstance = (instance: WebViewerInstance) => ({
    type: SET_WEBVIEWER_INSTANCE,
    instance,
})
export const setQuote = (quote: Quote) => ({
    type: SET_QUOTE,
    quote,
})

export const setQmrHoleDetails = (
    qmrWithHolesDetail?: quoteModelRevisionWithHoles,
) => ({
    type: SET_QMR_HOLE_DETAIL,
    qmrWithHolesDetail,
})

export const setQmrDFMFeedbackRevision = (
    qmrWithDfmFeedBack?: qmrDfmFeedBackquoteModelRevision | null,
) => ({
    type: SET_QMR_DFMFEEDBACK_REVISION,
    qmrWithDfmFeedBack,
})

export const setEditPdfMode = (editPdfMode: boolean) => ({
    type: SET_EDIT_PDF_MODE,
    editPdfMode,
})

export const setqmrAttachmentAnnotationsResponse = (
    qmrAttachmentAnnotations: any,
) => ({
    type: SET_ATTACHMENT_ANNOTATIONS_RESPONSE,
    qmrAttachmentAnnotations,
})

export const setShowLoading = (showLoading: boolean) => ({
    type: SET_SHOW_LOADING,
    showLoading,
})

export const setErrorMessage = (errorMessage: boolean) => ({
    type: SET_ERROR_MESSAGE,
    errorMessage,
})

export const setShowRFQModal = (showRFQModal: boolean) => ({
    type: SET_SHOW_RFQ_MODAL,
    showRFQModal,
})

export const setUnsavedAnno = (unsavedAnno: Annotations.Annotation[]) => ({
    type: SET_UN_SAVE_ANNOTATION,
    unsavedAnno,
})

export const setPdfInfoUserName = (userName: string) => ({
    type: SET_PDF_USER_INFO_USERNAME,
    userName,
})

export const setObfuscateFictivAnnotationAttribution = (
    obfuscateFictivAnnotationAttribution: boolean,
) => ({
    type: SET_OBFUSCATEFICTIVANNOTATATIONATTIBUTION,
    obfuscateFictivAnnotationAttribution,
})

export const setPdfUrl = (pdfUrl?: string | null) => ({
    type: SET_PDF_URL,
    pdfUrl,
})

export const setTechnicalSectionBackgroudColorForWarning = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    backgroudWarningColor: any,
) => ({
    type: SET_TECHNICAL_SECTION_BACKGROUD_COLOUR_FOR_WARNING,
    backgroudWarningColor,
})
